import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=04156811&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=04156811&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04156811",
  null
  
)

export default component.exports